
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
} from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import { stateType } from "./farmerDetail";
import { tourFarmerApi } from "../../../api/farmerSpace";
import store from "@/store/index";
import {getColorful} from "@/utils/util"
function stateInfo() {
  return {
    id: "",
    initInfo: {
      sourceTouristList: [],
    },
  };
}
export default defineComponent({
  setup() {
    const state = reactive<stateType>(stateInfo());
    const route = useRoute();
    const router = useRouter();
    state.id = route.params.id as string;
    onMounted(() => {
      tourFarmerApi(
        state.id,
        store.state.lngLat.lat,
        store.state.lngLat.lng
      ).then((res: any) => {
        state.initInfo = res.data.data;
      });
    });
    return {
      ...toRefs(state),
      ...fnList(state, router),
      getColorful
    };
  },
});
const fnList = (state: stateType, router: any) => {
  return {
    toDetail(id: string) {
      router.push({
        path: "/resourceDetail/" + id,
      });
    },
  };
};
